import type { FieldErrors } from "react-hook-form"

/**
 * Resolve the error message to show for a field.
 * Prefers the message from react-hook-form's `errors` object; falls back to
 * the static `fallback` string passed in from the parent component.
 */
export const extractErrorMessage = (
  errors: FieldErrors | undefined,
  name: string,
  fallback: string
): string => {
  const error = errors?.[name]
  return (error as { message?: string } | undefined)?.message || fallback
}
